export const EXTENSIONS = ['.styl', '.css'];
